<div class="logs">
  <button class="open-logs_btn preview-mode_btn" (click)="openLogs()">Logs</button>
</div>

@if (isLogsOpen) {
  <div class="logs_container" [@tabState]="state" [attr.data-state]="state" id="logsDrawer">
    <div class="clickatell-tabs logs_tabs">
      <div class="logs_header">
        <div class="logs_tabs_container" [@tabContainerState]="tabContainerState">
          <mat-tab-group #logsTabs animationDuration="300ms" disableRipple="true" class="clickatell-tabs"
            (selectedTabChange)="tabChanged()">
            <mat-tab>
              <ng-template mat-tab-label>Logs</ng-template>
              @if (logsTabs.selectedIndex === 0) {
                <ng-container
                  *ngTemplateOutlet="logs;  context: {logs: logsList, logType: 'logs', text:'logs'}">
                </ng-container>
              }
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>Keywords</ng-template>
              @if (logsTabs.selectedIndex === 1) {
                <ng-container
                  *ngTemplateOutlet="logs;  context: {logs: keywordLogsList, logType: 'keywords', text:'keywords'}">
                </ng-container>
              }
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>API Calls</ng-template>
              @if (logsTabs.selectedIndex === 2) {
                <ng-container
                  *ngTemplateOutlet="logs;  context: {logs: apiLogsList, logType: 'apis', text:'API calls'}">
                </ng-container>
              }
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>Variables</ng-template>
              @if (logsTabs.selectedIndex === 3) {
                <ng-container *ngTemplateOutlet="variablesTab">
                </ng-container>
              }
            </mat-tab>
          </mat-tab-group>
        </div>
        <button class="logs_arrow" (click)="expandLogs()" [@rotatedState]="rotateState"></button>
        <button class="logs_close" (click)="closeLogs()"></button>
      </div>
    </div>
  </div>
}


<ng-template #logs let-logs="logs" let-logType="logType" let-text="text">

  @if (logs | async; as dataSource) {
    <div class="tab logs-tab">
      @if (dataSource.length) {
        <table class="logs-table" mat-table [dataSource]="dataSource" multiTemplateDataRows matSort
          (matSortChange)="onMatSortChange($event, logType)">
          <ng-container matColumnDef="direction">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="direction">
              <span [ngClass]="element.direction + '-direction'" class="direction-icon"></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="step">
            <th mat-header-cell *matHeaderCellDef>
              Step
            </th>
            <td mat-cell *matCellDef="let element" class="step">
              @if (element.type==='start' || element.type==='error' || element.type ==='keyword') {
                <span class="start-step-icon"
                ></span>
              } @else {
                Step <span class="step-number">{{ element.step }}</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="interactions">
            <th mat-header-cell *matHeaderCellDef>
              Interactions
            </th>
            <td mat-cell *matCellDef="let element" class="interactions">
              <div class="interactions-cell">
                @if (element.type==='error') {
                  <div class="error-interaction">
                    <span class="error-interaction-img"></span>
                    <span>{{ element.interactions }}</span>
                  </div>
                } @else {
                  @if (element.interactions === 'chatHub') {
                    <img [src]="element.details.params.chathub.imageUrl" class="interaction-icon"
                      width="26" alt="element-type-image.svg" />
                      <span>{{ element.interactions | nodeName }}</span>
                    } @else {
                      <img src="../../../../../assets/svg/redesign/nodes/right-panel/{{element.type}}.svg"
                        class="interaction-icon" alt="element-type-image.svg" />
                        <span>{{ element.interactions | nodeName }}</span>
                      }
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef>
                  Details
                </th>
                <td #expandableDetailsParent mat-cell *matCellDef="let element" class="details"
                  [ngClass]="{'error-log': element.type==='error'}">
                  @if (element.type==='keyword' || element.type==='inputVoiceNote') {
                    <div class="interactive-node-details"
                      >
                      @if (element.type==='keyword') {
                        <div class="keywords-details">
                          <div class="node-type">"{{ element.details.input }}"</div>
                          <div class="equal"></div>
                          <div class="log-type">"{{ element.details.matchedKeyword }}"</div>
                          <div class="next"></div>
                          @if (element.details.showPath) {
                            <div #pathContainer class="path" data-type="pathContainer"
                              >
                              <ul #pathList data-type="pathList" [matTooltip]="element.details.path.tooltip"
                                matTooltipPosition="above" matTooltipHideDelay="200">
                                <ng-container pathNameTrimmer [flowLog]="element"
                                  [pathContainer]="pathContainer" [pathList]="pathList">
                                </ng-container>
                              </ul>
                              <li class="flow-name"><span class="flow-icon"></span>{{
                              element.details.path.flowName }}
                            </li>
                          </div>
                        } @else {
                          <div class="step">Step<span class="step-number">{{ element.details.step }}</span>
                        </div>
                      }
                    </div>
                  }
                  @if (element.type==='inputVoiceNote') {
                    <div class="input-voice-note">
                      <img class="icon" src="../../../../../assets/svg/redesign/voice-note-rec.svg" />
                    </div>
                  }
                </div>
              } @else {
                @if (actionTypes[element.type]) {
                  <div class="action-details"
                    #activeActionLog>
                    @if (element.type === actionTypes.httpCall || element.type === actionTypes.waitForCallback || element.type === actionTypes.chatHub) {
                      <div class="left-btn"
                        >
                        @if (element.type === actionTypes.httpCall;) {
                          <img class="icon"
                            src="../../../../../assets/svg/redesign/nodes/http-nodes-log.svg">
                          }
                          @if (element.type === actionTypes.waitForCallback;) {
                            <img class="icon"
                              src="../../../../../assets/svg/hourglass.svg">
                            }
                            {{ element.type === actionTypes.httpCall ? element.name :
                            element.details.params.chathub?.apiId}}
                          </div>
                        } @else {
                          <ng-container
                                       *ngTemplateOutlet="expandableDetailsTemplate;
                                       context: {
                                            parentElement: expandableDetailsParent,
                                            text: actionTypes[element.type] ? element.description : element.details
                                        }">
                          </ng-container>
                        }
                        @if (element !== expandedLogDetails) {
                          <div class="right-btn" (click)="toggleActionDetails(element, activeActionLog)">
                            View Details
                          </div>
                        } @else {
                          <div class="right-btn hide-action-btn" (click)="toggleActionDetails(element)">
                            Hide Details
                          </div>
                        }
                      </div>
                    } @else {
                      <ng-container
                                       *ngTemplateOutlet="expandableDetailsTemplate;
                                       context: {
                                            parentElement: expandableDetailsParent,
                                            text: actionTypes[element.type] ? element.description : element.details
                                        }">
                      </ng-container>
                    }
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="timestamp">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="timestamp">
                  Time Stamp
                  <span class="sort-icon sort-up"></span>
                  <span class="sort-icon sort-down"></span>
                </th>
                <td mat-cell *matCellDef="let element" class="time-stamp">
                  {{ element.timestamp | date : 'HH:mm:ss zzzz' }}
                </td>
              </ng-container>
              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="expandedDetail">
                <span>
                  <td mat-cell *matCellDef="let node" class="action-details-container action-details-tabs-hide"
                    [attr.colspan]="displayedColumns.length"
                    [@detailExpand]="node === this.expandedLogDetails ? 'expanded' : 'collapsed'">
                    @if (node['type'] === 'httpCall' || node['type'] === 'waitForCallback'
                      || node['type'] === 'chatHub' || node['type'] === 'optOut'
                      || node['type'] === 'verifyOptOut' || node['type'] === 'deleteOptOut') {
                      <mat-tab-group [selectedIndex]=selectedIndex
                        (selectedIndexChange)="selectedIndex = $event['index']" class="action-node-log-tabs"
                        (selectedTabChange)="onTabChanged($event, requestEditor, responseEditor, variablesEditor)"
                        [@detailExpand]="node === expandedLogDetails ? 'expanded' : 'collapsed'">
                        @if (node['type'] === 'httpCall' || node['type'] === 'optOut'
                          || node['type'] === 'verifyOptOut' || node['type'] === 'deleteOptOut') {
                          <mat-tab label="Request">
                            <div class="editor-container">
                              <div #requestEditor data-type="monacoEditor" class="action-log-editor">
                                <ng-container
                                  *ngTemplateOutlet="fontSizeControlsTemplate;context: {editor: requestEditor}">
                                </ng-container>
                              </div>
                            </div>
                          </mat-tab>
                        }
                        <mat-tab label="Response">
                          <div class="editor-container">
                            <div #responseEditor data-type="monacoEditor" class="action-log-editor">
                              <ng-container
                                *ngTemplateOutlet="fontSizeControlsTemplate;context: {editor: responseEditor}">
                              </ng-container>
                            </div>
                          </div>
                        </mat-tab>
                        <mat-tab label="Variables">
                          <div class="editor-container">
                            <div #variablesEditor data-type="monacoEditor" class="action-log-editor">
                              <ng-container
                                *ngTemplateOutlet="fontSizeControlsTemplate;context: {editor: variablesEditor}">
                              </ng-container>
                            </div>
                          </div>
                        </mat-tab>
                        @if (showHttpResponseCodeTimeList.includes(node['type'])) {
                          <mat-tab disabled>
                            <ng-template mat-tab-label>
                              <span class="details-label">HTTP Response: </span>
                                                <span class="response-code" [ngClass]="node.details.httpResponse.statusCode >= 200
                                                        && node.details.httpResponse.statusCode <= 299
                                                        ? 'response-code-success' : 'response-code-fail'">
                                {{node.details.httpResponse.statusCode}}
                              </span>
                            </ng-template>
                          </mat-tab>
                          <mat-tab disabled>
                            <ng-template mat-tab-label>
                              <span class="details-label">Response Time: </span>
                              <span
                              class="response-time">{{node.details.httpResponse.responseTime}}</span>
                            </ng-template>
                          </mat-tab>
                        }
                      </mat-tab-group>
                    } @else {
                      <mat-tab-group class="action-node-log-tabs default-action-node-log-tabs"
                        [selectedIndex]=selectedIndex
                                               (selectedIndexChange)="selectedIndex = $event['index']" (selectedTabChange)="onTabChanged(
                                          $event,
                                          null,
                                          null,
                                          variablesEditor,
                                          detailsEditor
                                          )" [@detailExpand]="node === expandedLogDetails ? 'expanded' : 'collapsed'">
                        <mat-tab label="Details">
                          <div class="editor-container">
                            <div #detailsEditor data-type="monacoEditor" class="action-log-editor">
                              <ng-container
                                *ngTemplateOutlet="fontSizeControlsTemplate;context: {editor: detailsEditor}">
                              </ng-container>
                            </div>
                          </div>
                        </mat-tab>
                        <mat-tab label="Variables">
                          <div class="editor-container">
                            <div #variablesEditor data-type="monacoEditor" class="action-log-editor">
                              <ng-container
                                *ngTemplateOutlet="fontSizeControlsTemplate;context: {editor: variablesEditor}">
                              </ng-container>
                            </div>
                          </div>
                        </mat-tab>
                      </mat-tab-group>
                    }
                  </td>
                </span>
              </ng-container>
              <!-- end expanded action log details section -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="logs-table-header"></tr>
              <tr mat-row *matRowDef="let row; let element; columns: displayedColumns" class="element-row"></tr>
              <tr mat-row class="action-details-row" *matRowDef="let row; columns: ['expandedDetail'];"
                [@detailExpand]="row === this.expandedLogDetails ? 'expanded' : 'collapsed'">
              </tr>
            </table>
          } @else {
            <ng-container *ngTemplateOutlet="defaultNoLogsTemplate;context: {text: text}">
            </ng-container>
          }
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="defaultNoLogsTemplate;context: {text: text}">
        </ng-container>
      }

    </ng-template>


    <ng-template #variablesTab>
      @if (variableTabList | async; as dataSource) {
        <div class="variable-table">
          <div class="variable-table-row variable-table-first-row">
            <div class="var-key-container">Variable Name</div>
            <div class="var-value-container">Value
              <div class="var-search-container">
                <input [ngModel]="variableSearch" (ngModelChange)="filterVariables($event)"
                  class="var-search" placeholder="Search variables...">
                  @if (variableSearch) {
                    <div class="clear-search" (click)="clearSearchVar()"></div>
                  }
                </div>
              </div>
            </div>
            @if (dataSource.length) {
              @for (row of dataSource; track row) {
                <div #variableTableRow class="variable-table-row">
                  <div class="var-key-container">
                    <div class="var-key">
                      [[<span class="var-key-limit">{{ row.key }}</span>]]
                    </div>
                    <div class="copy-img-container" (click)="copyKey(row.key)">
                      <img class="copy-img" src="../../../../../assets/svg/redesign/variable-copy.svg">
                    </div>
                  </div>
                  <div class="var-value-container">
                    @if (row.longText) {
                      <div class="var-value-label" >
                        {{row.value}}
                      </div>
                    } @else {
                      <div #rowValue class="var-value-label" >
                        {{row.value}}
                        @if (rowValue.classList.contains('expanded')) {
                          <span class="toggle-show-details-btn show-less-btn" (click)="toggleVarValue(variableTableRow, rowValue)">Show less</span>
                        }
                      </div>
                      @if (rowValue.scrollWidth > rowValue.clientWidth && !rowValue.classList.contains('expanded')) {
                        <span class="toggle-show-details-btn show-less-btn" (click)="toggleVarValue(variableTableRow, rowValue)">Show more</span>
                      }
                    }
                  </div>
                  <div></div>
                </div>
              }
            } @else {
              <ng-container *ngTemplateOutlet="defaultNoLogResultsTemplate;context: {text: 'variables', search:variableSearch}">
              </ng-container>
            }
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="defaultNoLogResultsTemplate;context: {text: 'variables', search:variableSearch}">
          </ng-container>
        }

      </ng-template>

      <ng-template #fontSizeControlsTemplate let-editorHTMLElementRef="editor">
        <div class="font-size-container">
          <div class="decrease-font-btn" (click)="decreaseFontSize(editorHTMLElementRef)"> -</div>
          <div class="reset-font-btn" (click)="resetFontSize(editorHTMLElementRef)"><span>a/A</span></div>
          <div class="increase-font-btn" (click)="increaseFontSize(editorHTMLElementRef)"> +</div>
        </div>
      </ng-template>

      <ng-template #defaultNoLogsTemplate let-text="text">
        <p class="no-data-text">
          No {{text}} to display
        </p>
      </ng-template>

      <ng-template #defaultNoLogResultsTemplate let-text="text" let-search="search">
        <p class="no-data-text" >
          {{ search ? 'No results found.' : 'No ' + text + ' to display' }}
        </p>
      </ng-template>

      <ng-template #expandableDetailsTemplate let-parentElement="parentElement" let-text="text">
        <div #spanContainer class="expandable-text-container">
          <div #detailsSpan class="details-span truncated">
            {{text}}
          </div>
          <span [ngClass]="{'hide-more-btn' : detailsSpan.scrollWidth <= detailsSpan.offsetWidth}"
            #showMoreBtn class="toggle-show-details-btn show-more-btn"
          (click)="toggleDetailsText(detailsSpan, showMoreBtn)">Show more</span>
          <span class="toggle-show-details-btn show-less-btn"
            showMoreShowLess [spanContainer]="spanContainer" [detailsSpan]="detailsSpan"
          (click)="toggleDetailsText(detailsSpan, showMoreBtn)">Show less</span>
        </div>
      </ng-template>